import {TextField} from '@wellstone-solutions/web';
import {useNoteForm} from '../../NoteForm';
import {FOLLOW_UPS, FOLLOW_UP_WITH_CLIENT} from '../choices';
import type {ContactNoteAction, ContactNoteState} from '../state';
import {ChecklistNoteSection} from './ChecklistNoteSection';

export const FollowUpSection = () => {
  const {state, dispatch} = useNoteForm<ContactNoteState, ContactNoteAction>();

  return (
    <ChecklistNoteSection
      label="What happens next?"
      options={FOLLOW_UPS}
      field="followUps"
      noteField="followUpPlan"
      noteLabel="Follow-up plan">
      {state.followUps.selected.includes(FOLLOW_UP_WITH_CLIENT) && (
        <TextField
          required
          type="datetime-local"
          label="Follow-up date/time"
          value={state.followUpAt}
          InputLabelProps={{shrink: true}}
          sx={{maxWidth: 320}}
          onChange={(event) =>
            dispatch({
              type: 'set',
              field: 'followUpAt',
              value: event.target.value,
            })
          }
        />
      )}
    </ChecklistNoteSection>
  );
};
